import React, { FC, ReactNode } from 'react';

import { AIAgentsHubProvider } from './Agents/AiAgentsHubContext';
import { PromptsAdminPage } from './Agents/PromptsAdmin';

const TeamAIPromptsPage: FC = () => {
  const [action, setAction] = React.useState<ReactNode>(null);

  return (
    <AIAgentsHubProvider action={action} setAction={setAction}>
      <PromptsAdminPage embedded={false} />
    </AIAgentsHubProvider>
  );
};

export default React.memo(TeamAIPromptsPage);
